<template>
    <div class="panel-group container-fluid">
        <div
            v-for="(category) in $_data"
            v-if="category.items && category.items.length > 0"
            class="panel dash-row"
        >
            <h3 v-if="isGroupsMode">
                <a class="dash-group" href="javascript:;" @click="toggle(category.name)">
                    <i class="fa arrow" :class="[isExpanded(category.name) ? 'fa-chevron-circle-down' : 'fa-chevron-circle-right']"></i>
                    <span>{{ category.title }}</span>
                </a>
            </h3>
            <transition
                v-on:enter="enterTransition"
                v-on:leave="leaveTransition"
                v-bind:css="false"
            >
                <div v-show="isExpanded(category.name)" :class="['panel-body', category.name !== 'undefined' ? `category-${category.name}` : '']">
                    <ul>
                        <li v-for="(item, index) in category.items">
                            <oc-action
                                class="link-image"
                                v-bind="getDashIconLinkAttrs(item, category.name)"
                                v-on="getDashIconLinkEvents(item, category.name)"
                                :displayTitle="false"
                            />

                            <oc-action
                                class="link-title"
                                v-bind="getDashIconLinkAttrs(item, category.name)"
                                v-on="getDashIconLinkEvents(item, category.name)"
                                :icon="false"
                            />
                        </li>
                    </ul>
                </div>
            </transition>
         </div>
    </div>
</template>
<script>
import Velocity from 'velocity'

export default {
    name: 'oc-dashboard',
    props: {
        /**
         * [
         *     {
         *         name: 'services',
         *         expand: true,
         *         title: 'Category title ex.: Services',
         *         color: '#623456',
         *         items: [
         *             {title: 'My Icon', link: '/shared/tags/', icon: 'pencil', target: '_blank'}
         *         ]
         *     }
         * ]
         *
         * OR
         *
         * {
         *     services: {
         *         expand: true,
         *         title: 'Category title ex.: Services',
         *         color: '#623456',
         *         items: [
         *             {title: 'My Icon', link: '/shared/tags/', icon: 'pencil', target: '_blank'}
         *         ]
         *     }
         * }
         *
         * OR without groups
         *
         * [
         *     {title: '', link: '', icon: '', target: ''}
         * ]
         *
         * -----------------------------------
         *
         * If you want to overwrite the click event - you will need to change the default tag from "router-link" to "a".
         * This is due to: https://github.com/vuejs/vue-router/issues/800
         *
         * Example:
         *
         * [
         *     {
         *         title: 'My custom click',
         *         tag: 'a',
         *         onClick(row) {
         *             w(row)
         *         }
         *     }
         * ]
         *
         * @type {Object|Array}
         */
        data: {
            type: [Object, Array],
            default: () => []
        },
        startExpanded: {
            type: Boolean,
            default: false
        },
        defaultItemsColor: {
            type: [String, Boolean],
            default: false
        },
        iconAttrs: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            expandedCategories: {}
        }
    },
    computed: {
        isGroupsMode(){
            if( ! isArray(this.data) ) {
                return true
            }

            let result = false
            for( let i in this.data ) {
                if( this.data[i].items !== undefined || this.data[i].expand !== undefined ) {
                    result = true
                    break
                }
            }

            return result
        },
        $_data() {
            let data
            if( isArray(this.data) ) {
                data = this.data.slice(0)
            } else {
                data = Object.assign({}, this.data)
            }

            if( this.isGroupsMode )
            {
                if( ! isArray(data) ) {
                    for( let categoryName in data ) {
                        data[categoryName].name = categoryName
                    }
                }

                return data
            }

            return {
                undefined: {
                    items: data
                }
            }
        }
    },
    methods: {
        getDashIconLinkEvents(item, categoryName) {
            return item.events ? item.events : {}
        },
        getDashIconLinkAttrs(item, categoryName) {
            let attrs = Object.assign({}, {
                tag: 'router-link',
                to: item.link,
                target: item.target ? item.target : '_self'
            }, item)

            let linkAttrs = {
                title: item.title
            }

            if( isObject(attrs.linkAttrs) ) {
                attrs.linkAttrs = Object.assign(attrs.linkAttrs, linkAttrs)
            } else {
                attrs.linkAttrs = linkAttrs
            }

            // -------

            let iconAttrs = {
                class: 'dash-icon',
                type: item.icon,
                style: {
                    color: this.getColor(categoryName)
                }
            }

            if( isObject(attrs.iconAttrs) ) {
                attrs.iconAttrs = Object.assign({}, this.iconAttrs, attrs.iconAttrs, iconAttrs)
            } else {
                attrs.iconAttrs = Object.assign({}, this.iconAttrs, iconAttrs)
            }

            return attrs
        },
        findCategoryItem(categoryName) {
            if( isArray(this.data) ) {
                return this.data.find( x => x.name === categoryName )
            }

            return this.data[categoryName]
        },
        getColor(categoryName) {
            let category = this.findCategoryItem(categoryName)

            if( category !== undefined && category.color ) {
                return category.color
            }

            return this.defaultItemsColor
        },
        isExpanded(categoryName) {
            if( ! this.isGroupsMode ) {
                return true
            }

            let category = this.findCategoryItem(categoryName)

            if(
                ( category && category.expand || this.startExpanded) &&
                this.expandedCategories[categoryName] === undefined
            ) {
                return true
            }

            return this.expandedCategories[categoryName] === true
        },
        toggle(categoryName) {
            if( this.isExpanded(categoryName) ) {
                Vue.set(this.expandedCategories, categoryName, false)
                return
            }

            Vue.set(this.expandedCategories, categoryName, true)
        },
        enterTransition (el, done) {
            Velocity(el, "slideDown", { duration: 350, complete: done, easing: 'ease-in-out' })
        },
        leaveTransition (el, done) {
            Velocity(el, "slideUp", { duration: 350, complete: done, easing: 'ease-in-out' })
        }
    }
}
</script>
<style scoped>
.dash-row * {
	font-size: 14px;
	line-height: 21px;
}

.dash-row {
    margin-bottom: 1.2em;
    overflow: hidden;
    zoom: 1;
}
.dash-row h3 {
    line-height: 21px;
    margin-bottom: 10px;
}
    .dash-row h3 a {
        transition: none;
        display: inline-block;
        font-size: 15px;
        line-height: 21px;
        color: #4c5264;
        text-transform: uppercase;
        text-decoration: none;
    }
    .dash-row h3 .arrow {
        margin-right: 2px;
    }

.dash-row >>> .dash-icon {
    color: #000;
    font-size: 33px;
}
.dash-row ul {
    overflow: hidden;
    zoom: 1;
    padding: 0;
    margin: 0;
}
    .dash-row ul li {
        display: inline-block;
    	width: 10em;
    	height: 6em;
    	padding: 0em;
    	margin: 0em 0.7em 0.7em 0em;
    	background: #f9f9f9;
    	border: solid 1px #dbdbdb;
    	text-align: center;
    	/* List Style */
    	list-style-image: none;
    	list-style-position: outside;
    	list-style-type: none;
    }
    .dash-row ul li:hover {
        background: #f1f1f1;
    }

    .dash-row ul li >>> a {
        display: block;
        outline: none;
        transition: none;
        text-align: center;
        vertical-align: middle;
        text-decoration: none;
    }

    .dash-row >>> ul li .link-image {
    	height: 4em;
    }

    .dash-row >>> ul li .link-image .dash-icon {
    	display: inline-block;
    	margin-top: 0.5em;
    	font-size: 2.3em;
    	line-height: 1em;
    	color: #000;
    }

    .dash-row >>> ul li .link-title {
    	height: 1.75em;
    	color: #7d8e9a;
    	padding: 0em 0.5em;
    	white-space: nowrap;
    	overflow: hidden;
    	text-overflow: ellipsis;
    }
</style>
